'use es6';

import authHttp from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import GoodSubTypes from '../constants/GoodSubTypes';
import GoodSubTypeGroups from '../constants/GoodSubTypeGroups';
import IndustryOptions from '../constants/IndustryOptions';
import TemplatePurposeOptions from '../constants/TemplatePurposeOptions';
import PaymentMethods from '../constants/PaymentMethods';
import PageLayoutOptions from '../constants/PageLayoutOptions';
import ProviderOptions from '../constants/ProviderOptions';
import SystemPageSubTypes from '../constants/SystemPageSubTypes';
import { getSubTypesBelongingToGroup } from '../utils/utils';
var BASE_V3_ENDPOINT = 'productmarketplaceapi/v3';
var DETAILS_ENDPOINT = BASE_V3_ENDPOINT + "/goods/details";
var DIRECTORY_ENDPOINT = BASE_V3_ENDPOINT + "/goods/directory";
var BASE_PURCHASE_ENDPOINT = BASE_V3_ENDPOINT + "/good/purchases";
var PROVIDERS_ENDPOINT = BASE_V3_ENDPOINT + "/providers";
var PAYPAL_CODE_ENDPOINT = 'paypal-code';
var LANDING_AND_SITE_PAGE_CREATE_ENDPOINT = 'content/api/v4/landing-pages';
var EMAIL_CREATE_ENDPOINT = 'cosemail/v1/emails';
export default {
  getDeliverStatus: function getDeliverStatus(goodId) {
    return authHttp.get(BASE_PURCHASE_ENDPOINT + "/" + goodId + "/deliver-status");
  },
  getGoods: function getGoods(params, isCustomer) {
    var opts = {
      query: {
        tag: [],
        childTypeAnd: []
      }
    };
    params.forEach(function (val, key) {
      if (key === GoodFiltersAndPage.PRICE) {
        if (val.size === 1) {
          opts.query[GoodFiltersAndPage.PRICE] = val.get('0');
        }
      } else if (key === GoodFiltersAndPage.CODING_TYPE) {
        if (val.size === 1) {
          opts.query.tag.push(val.get('0'));
        }
      } else if (key === GoodFiltersAndPage.PAGE_LAYOUT) {
        if (val === PageLayoutOptions.ALL) {
          return;
        }

        opts.query.tag.push(val);
      } else if (key === GoodFiltersAndPage.INDUSTRY) {
        if (val === IndustryOptions.ALL) {
          return;
        }

        opts.query.tag.push(val);
      } else if (key === GoodFiltersAndPage.TEMPLATE_PURPOSE) {
        if (val === TemplatePurposeOptions.ALL) {
          return;
        }

        opts.query.tag.push(val);
      } else if (key === GoodFiltersAndPage.PROVIDER) {
        if (val === ProviderOptions.ALL) {
          return;
        }

        opts.query[key] = val;
      } else if (key === GoodFiltersAndPage.SUB_TYPE && val === GoodSubTypes.ALL) {
        return;
      } else if (key === GoodFiltersAndPage.SUB_TYPE && (val === GoodSubTypeGroups.SYSTEM_PAGE_TEMPLATES || val === GoodSubTypeGroups.PAGE_TEMPLATES || val === GoodSubTypeGroups.TEMPLATES)) {
        opts.query[key] = getSubTypesBelongingToGroup(val);
      } else if (key === GoodFiltersAndPage.FEATURES || key === GoodFiltersAndPage.MODULE_PURPOSE || key === GoodFiltersAndPage.MODULE_COMPATIBILITY) {
        val.forEach(function (tag) {
          opts.query.tag.push(tag);
        });
      } else if (key === GoodFiltersAndPage.CHILD_TYPES) {
        val.forEach(function (childType) {
          if (childType === GoodSubTypeGroups.SYSTEM_PAGE_TEMPLATES) {
            opts.query.childTypeOr = [SystemPageSubTypes.UNSUBSCRIBE_SIMPLE, SystemPageSubTypes.ERROR_PAGE, SystemPageSubTypes.PASSWORD_PAGE, SystemPageSubTypes.SUBSCRIPTION_PREFERENCES, SystemPageSubTypes.UNSUBSCRIBE_CONFIRMATION, SystemPageSubTypes.CONTENT_SEARCH_RESULTS];
          } else {
            opts.query.childTypeAnd.push(childType);
          }
        });
      } else {
        opts.query[key] = val;
      }
    });

    if (isCustomer) {
      return authHttp.get("" + DIRECTORY_ENDPOINT, opts);
    }

    return noAuthHttp.get("" + DIRECTORY_ENDPOINT, opts);
  },
  getGoodDetails: function getGoodDetails(providerUrlToken, goodNameUrlToken, previewMode, isCustomer) {
    var urlToken = providerUrlToken ? providerUrlToken + "/" + goodNameUrlToken : goodNameUrlToken;
    var queryParam = previewMode ? '?latest=true' : '';
    var earlyRequestName = "good-details-" + urlToken;
    var earlyRequest = window.quickFetch && window.quickFetch.getRequestStateByName(earlyRequestName);

    var fetchData = function fetchData() {
      return isCustomer ? authHttp.get(DETAILS_ENDPOINT + "/" + urlToken + queryParam) : noAuthHttp.get(DETAILS_ENDPOINT + "-no-auth/" + urlToken + queryParam);
    };

    if (earlyRequest) {
      return new Promise(function (resolve, reject) {
        earlyRequest.whenFinished(function (result) {
          resolve(result);
          window.quickFetch.removeEarlyRequest(earlyRequestName);
        });
        earlyRequest.onError(function () {
          fetchData().then(resolve).catch(reject);
          window.quickFetch.removeEarlyRequest(earlyRequestName);
        });

        if (window.newrelic) {
          window.newrelic.setCustomAttribute('good-details-early-request-used', Boolean(earlyRequest.finished));
        }
      });
    }

    return fetchData();
  },
  getProviderNames: function getProviderNames() {
    return noAuthHttp.get(PROVIDERS_ENDPOINT + "/names");
  },
  getPurchasedGoods: function getPurchasedGoods() {
    var earlyRequestName = 'manage-purchases';
    var earlyRequest = window.quickFetch && window.quickFetch.getRequestStateByName(earlyRequestName);

    var fetchData = function fetchData() {
      return authHttp.get(BASE_PURCHASE_ENDPOINT);
    };

    if (earlyRequest) {
      return new Promise(function (resolve) {
        earlyRequest.whenFinished(function (result) {
          resolve(result);
          window.quickFetch.removeEarlyRequest(earlyRequestName);
        });
        earlyRequest.onError(function () {
          fetchData().then(resolve);
          window.quickFetch.removeEarlyRequest(earlyRequestName);
        });

        if (window.newrelic) {
          window.newrelic.setCustomAttribute('manage-purchases-early-request-used', Boolean(earlyRequest.finished));
        }
      });
    }

    return fetchData();
  },
  getPaginatedPurchasedGoods: function getPaginatedPurchasedGoods(_ref) {
    var offset = _ref.offset,
        limit = _ref.limit;
    var earlyRequestName = 'manage-purchases-paginated';
    var earlyRequest = window.quickFetch && window.quickFetch.getRequestStateByName(earlyRequestName);

    var fetchData = function fetchData() {
      return authHttp.get(BASE_PURCHASE_ENDPOINT + "/all", {
        query: {
          offset: offset,
          limit: limit
        }
      });
    };

    if (earlyRequest) {
      return new Promise(function (resolve) {
        earlyRequest.whenFinished(function (result) {
          resolve(result);
          window.quickFetch.removeEarlyRequest(earlyRequestName);
        });
        earlyRequest.onError(function () {
          fetchData().then(resolve);
          window.quickFetch.removeEarlyRequest(earlyRequestName);
        });

        if (window.newrelic) {
          window.newrelic.setCustomAttribute('manage-purchases-paginated-early-request-used', Boolean(earlyRequest.finished));
        }
      });
    }

    return fetchData();
  },
  purchaseGood: function purchaseGood(paymentMethod, data) {
    var opts = {
      data: data,
      timeout: 20000
    };

    if (paymentMethod === PaymentMethods.PAYPAL) {
      return authHttp.post(BASE_PURCHASE_ENDPOINT + "/" + PAYPAL_CODE_ENDPOINT, opts);
    }

    return authHttp.post("" + BASE_PURCHASE_ENDPOINT, opts);
  },
  submitRefund: function submitRefund(transactionId, reason) {
    var opts = {
      data: {
        reason: reason
      },
      timeout: 20000
    };
    return authHttp.post(BASE_PURCHASE_ENDPOINT + "/" + transactionId + "/refund", opts);
  },
  updateRefund: function updateRefund(transactionId, status, reason) {
    var opts = {
      data: {
        status: status,
        reason: reason
      }
    };
    return authHttp.put(BASE_PURCHASE_ENDPOINT + "/" + transactionId + "/refund", opts);
  },
  submitReview: function submitReview(goodId, transactionId, rating, commentText) {
    var opts = {
      data: {
        rating: rating,
        contents: commentText
      }
    };
    return authHttp.post(BASE_V3_ENDPOINT + "/goods/" + goodId + "/review/" + transactionId, opts);
  },
  createPageAsset: function createPageAsset(name, templatePath) {
    var subcategory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return authHttp.post(LANDING_AND_SITE_PAGE_CREATE_ENDPOINT, {
      data: {
        name: name,
        templatePath: templatePath,
        subcategory: subcategory
      }
    });
  },
  createEmailAsset: function createEmailAsset(name, templatePath) {
    return authHttp.post(EMAIL_CREATE_ENDPOINT, {
      data: {
        name: name,
        templatePath: templatePath
      }
    });
  },
  reinstallGood: function reinstallGood(goodId) {
    var opts = {
      data: {
        goodId: goodId
      }
    };
    return authHttp.post(BASE_PURCHASE_ENDPOINT + "/redownload", opts);
  },
  uninstallGood: function uninstallGood(transactionId) {
    var skipValidation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var opts = {
      data: {},
      query: {
        skipValidation: skipValidation
      }
    };
    return authHttp.post(BASE_PURCHASE_ENDPOINT + "/" + transactionId + "/uninstall", opts);
  },
  getGoodData: function getGoodData(goodId) {
    var isCustomer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var httpClient = isCustomer ? authHttp : noAuthHttp;
    return httpClient.get(BASE_V3_ENDPOINT + "/goods/" + goodId + "/data");
  },
  getRecommendedApps: function getRecommendedApps(_ref2) {
    var count = _ref2.count;
    return authHttp.get(BASE_V3_ENDPOINT + "/goods/recommended", {
      query: {
        count: count
      }
    });
  },
  getStripeSessionId: function getStripeSessionId(goodId) {
    return authHttp.post(BASE_V3_ENDPOINT + "/good/purchases/stripe", {
      data: {
        goodId: goodId
      }
    });
  }
};